import {ChangeDetectorRef, Component, NgZone, OnInit} from '@angular/core';

@Component({
    selector: 'app-clock',
    templateUrl: './clock.component.html',
    styleUrl: './clock.component.scss',
    standalone: false
})
export class ClockComponent implements OnInit {
  currentDate = new Date();

  constructor(private cd: ChangeDetectorRef, private ngZone: NgZone) {}

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      setInterval(() => {
        this.currentDate = new Date();
        this.cd.detectChanges();
      }, 1000);
    });
  }
}
